export default "__VITE_ASSET__DTtT9B55__"